import { createElement, StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { ShowPets } from "./ShowPets.tsx";
import PetDetailWrapper from "./PetDetailWrapper.tsx";

const rootElem = document.getElementById("root");
if (rootElem) {
  createRoot(document.getElementById("root")).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

const SH_PETS_COMPONENTS = {
  ShowPets,
  PetDetailWrapper,
};

function shPetsHydrate(
  element: HTMLElement,
  componentName: string,
  props: any,
) {
  const component = SH_PETS_COMPONENTS[componentName];

  if (component) {
    createRoot(element).render(
      <StrictMode>{createElement(component, props)}</StrictMode>,
    );
  }
}

Object.assign(window, { shPetsHydrate, SH_PETS_COMPONENTS });
